import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '../../styles/StyledButtons';
import { StyledTypography } from '../../styles/styles';

interface NavigateWithMessageProps {
  to: string;
  children: React.ReactNode;
}

export default function NavigateWithMessage({ to, children }: NavigateWithMessageProps) {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(to);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, to]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      p={3}
    >
      <StyledTypography variant="h6" gutterBottom>
        {children}
      </StyledTypography>

      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <StyledTypography variant="h6" color="text.secondary">
          Redirecting in {countdown} seconds...
        </StyledTypography>
        <StyledTypography variant="h6" color="text.secondary">
          or
        </StyledTypography>
        <StyledButton onClick={() => navigate(to)}>click here</StyledButton>
      </Box>
    </Box>
  );
}
